import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames/bind";
import Styles from "./auth.module.scss";
import { updateTab } from "../../redux/slices/app";
import Header from "../Header/Header";

const cx = classNames.bind(Styles);

const AuthLayout = () => {
  const dispatch = useDispatch();

  const { tab } = useSelector((state) => state.app);
  const { isLoggedIn } = useSelector((state) => state.auth);
  if (isLoggedIn) {
    dispatch(updateTab("home"))
    return <Navigate to={"/mongolia/home"} />;
  }
  return (
   
    <div className={cx("wrapper")}>
      <Outlet />
    </div>
    
  );
};

export default AuthLayout;
